
const StartButton = ({
    text,
    onClick
}) => {

    return (
        <button onClick={onClick} role="button" className="button button--green">
         {text}
        </button>
    )
}

export default StartButton